import { create } from 'zustand';

export interface Booking {
  id: string;
  courseType: string;
  date: string;
  time: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  notes?: string;
  status: 'confirmed' | 'pending' | 'cancelled';
  createdAt: string;
}

interface BookingStore {
  bookings: Booking[];
  addBooking: (booking: Omit<Booking, 'id' | 'status' | 'createdAt'>) => Booking;
  cancelBooking: (id: string) => void;
}

export const useBookingStore = create<BookingStore>((set) => ({
  bookings: JSON.parse(localStorage.getItem('3bt_bookings') || '[]'),
  
  addBooking: (bookingData) => {
    const booking: Booking = {
      ...bookingData,
      id: `BK-${Date.now()}-${Math.random().toString(36).substr(2, 4).toUpperCase()}`,
      status: 'confirmed',
      createdAt: new Date().toISOString(),
    };
    
    set((state) => {
      const updated = [...state.bookings, booking];
      localStorage.setItem('3bt_bookings', JSON.stringify(updated));
      return { bookings: updated };
    });
    
    // Trigger email confirmation (simulated)
    sendEmailConfirmation(booking);
    
    return booking;
  },
  
  cancelBooking: (id) => {
    set((state) => {
      const updated = state.bookings.map(b => 
        b.id === id ? { ...b, status: 'cancelled' as const } : b
      );
      localStorage.setItem('3bt_bookings', JSON.stringify(updated));
      return { bookings: updated };
    });
  },
}));

function sendEmailConfirmation(booking: Booking) {
  // Simulated email confirmation
  console.log(`📧 Email confirmation sent to ${booking.email}`);
  console.log(`📋 Booking ID: ${booking.id}`);
  console.log(`🎯 Course: ${booking.courseType} on ${booking.date} at ${booking.time}`);
  
  // In production, this would call an API endpoint
  // For WhatsApp notification, open WhatsApp link
  const message = encodeURIComponent(
    `🔥 NEW BOOKING - 3B Tactical\n\n` +
    `Name: ${booking.firstName} ${booking.lastName}\n` +
    `Course: ${booking.courseType}\n` +
    `Date: ${booking.date} at ${booking.time}\n` +
    `Email: ${booking.email}\n` +
    `Phone: ${booking.phone}\n` +
    `Booking ID: ${booking.id}`
  );
  
  // Store notification for later sending
  const notifications = JSON.parse(localStorage.getItem('3bt_notifications') || '[]');
  notifications.push({
    type: 'booking',
    booking: booking,
    whatsappUrl: `https://wa.me/17867526622?text=${message}`,
    sent: false,
    createdAt: new Date().toISOString(),
  });
  localStorage.setItem('3bt_notifications', JSON.stringify(notifications));
}
